import React from "react"
import { Switch, Route } from "react-router-dom"
import Login from './auth/Login'
import Register from './auth/Register'
import ActivationMail from "./auth/ActivationMail"
import { useSelector } from "react-redux"
import ForgotPassword from "../body/auth/ForgotPassword"
import ResetPassword from "../body/auth/ResetPassword"
import Profile from "../body/profile/Profile"
import About from "../body/About/About"
import Home from "../body/Home/Home"
import MainTable from "./MainTable/MainTable"
import DemoTable from "./DemoTable/DemoTable"

export default function Body() {

    const auth = JSON.parse(localStorage.getItem('login'));
    const isLogged = auth ? auth.isLogged : false;

    return ( 
        <div className="body-container">
            <Switch>
                <Route path="/" component={isLogged ? MainTable : Home} exact />
                <Route path="/about" component={About} exact />
                {
                    isLogged ?
                        <>
                            <Route path="/profile" component={Profile} exact />
                            <Route path="/forgot_password" component={ForgotPassword} exact />
                            <Route path="/user/reset/:token" component={ResetPassword} exact />
                            <Route path="/login" component={MainTable} exact />
                            <Route path="/register" component={MainTable} exact />
                        </>
                        :
                        <>
                            <Route path="/login" component={Login} exact />
                            <Route path="/register" component={Register} exact />
                            <Route path="/user/activate/:activation_token" component={ActivationMail} exact />
                            <Route path="/profile" component={Home} exact />
                            <Route path="/demo" component={DemoTable} exact />
                        </>
                }

            </Switch>
        </div>
    )
}
